import { DimensionListener } from './Responsive.types';

/**
 * Subscribes to changes in screen width. Should not be used outside of Responsive module.
 * @param listener The callback to call when width changes. Called immediately with the present
 * with.
 * @returns A function to call to unsubscribe from notification
 */
export function listenToWidth(listener: DimensionListener): () => void {
  const listen = () => {
    listener(window.innerWidth);
  };

  window.addEventListener('resize', listen);
  listener(window.innerWidth);

  return () => {
    window.removeEventListener('resize', listen);
  };
}
